// Write your code here
import {Component} from 'react'
import './index.css'
import SuggestionItem from '../SuggestionItem'

class GoogleSuggestions extends Component {
  state = {
    inputVal: '',
  }

  changeItem = suggestion => {
    this.setState({
      inputVal: suggestion,
    })
  }

  changeInputVal = event => {
    this.setState({
      inputVal: event.target.value,
    })
  }

  render() {
    const {inputVal} = this.state
    const {suggestionsList} = this.props
    const results = suggestionsList.filter(each =>
      each.suggestion.toLowerCase().includes(inputVal.toLowerCase()),
    )
    return (
      <div className="main-container">
        <div className="card">
          <img
            alt="google logo"
            src="https://assets.ccbp.in/frontend/react-js/google-logo.png"
            className="google-image"
          />
          <div className="half-card">
            <div className="search-container">
              <img
                className="search"
                alt="search icon"
                src="https://assets.ccbp.in/frontend/react-js/google-search-icon.png"
              />
              <input
                value={inputVal}
                onChange={this.changeInputVal}
                placeholder="Search Google"
                type="search"
              />
            </div>
            <ul className="list-container">
              {results.map(each => (
                <SuggestionItem
                  changeItem={this.changeItem}
                  key={each.id}
                  item={each}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
export default GoogleSuggestions
